export default __webpack_public_path__ + "media/images/theme/bg_light-c66fc95968820bb29f1d099491a1042f.png";